
import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";

import Button from "../Button";

function Switcher() {

  const { t } = useTranslation();

  const [active, setActive] = useState(0);

  const data = [
    {
      title: t('fees.11'),
      text1: t('fees.16'),
      text2: t('fees.17'),
    },
    {
      title: t('fees.12'),
      text1: t('fees.18'),
      text2: t('fees.19'),
    },
    {
      title: t('fees.13'),
      text1: t('fees.20'),
      text2: t('fees.21'),
    },
    {
      title: t('fees.14'),
      text1: t('fees.22'),
      text2: t('fees.23'),
    },
    {
      title: t('fees.15'),
      text1: t('fees.24'),
      text2: t('fees.25'),
    },
  ]

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="flex flex-col md:flex-row gap-[6px] xl:gap-[20px]">
                <div className="flex flex-col gap-[6px] xl:gap-[10px] flex-shrink-0">
                  {data.map((item, index) => (
                    <div key={index} className={`py-[12px] xl:py-[16px] px-[20px] xl:px-[36px] transition-all cursor-my ${active === index ? 'bg-[#1E1C21] border' : 'bg-[#FFFFFF] border border-[#00000033]'}`} onClick={() => setActive(index)}>
                        <p className={`zen-dots text-[16px] xl:text-[20px] transition-all ${active === index ? 'text-[#FFFFFF]' : 'text-[#1E1C21]'}`}>{item.title}</p>
                    </div>
                  ))}
                </div>
                <div className="w-full h-[359px] bg-white border-[#00000033] border flex flex-col items-start relative">
                  <p className="pt-[30px] px-[20px] xl:px-[60px] zen-dots text-[20px] xl:text-[24px]">{data[active].title}</p>
                  <p className="mt-[12px] xl:max-w-[650px] text-[#000000B2] px-[20px] xl:pl-[60px] ibm-plex text-[12px] xl:text-[14px]">{data[active].text2}</p>
                  <div className="flex mt-[25px] gap-[10px] xl:gap-[20px] items-center">
                    <div className="w-[2px] h-[32px] bg-[#1E1C21] ml-[20px] xl:ml-[60px]"></div>
                    <p className="ibm-plex text-[12px] xl:text-[14px] text-[#000000] font-[500] xl:max-w-[278px]">{data[active].text1}</p>
                  </div>
                  <Button className={'px-[20px] xl:px-[60px] absolute bottom-[20px]'}/>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Switcher;
